<template>
  <v-content id="homepage">
    <section>
      <v-parallax src="/img/header-background.jpg" height="450"></v-parallax>
    </section>
  </v-content>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {

  created() {
    if (this.$route.path === '/candidate/signup') window.location.replace('/login?signup')
    // Only redirect in production to ease development flow
    if (process.env.NODE_ENV === 'production')
      setTimeout(() => window.location.replace('https://about.leap.ly/'), 2000)

  },
  computed: mapGetters({ role: 'auth/role' }),
}
</script>

<style>
main#homepage {
  padding-top: 0 !important;
}
</style>
